import { useEffect, useState } from "react";
import { Box, Grid, Tooltip, Typography, TextField, InputAdornment } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import GridTableData from "./GridTableData";
import NoResultsPublished from "./NoResultsPublished";
import { TYPE_KB } from "../../global/constants";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "0 0 0 0", justifyItems: "center" }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const FleetRaceTabsv2 = (props) => {
  const [value, setValue] = useState(0);
  const [selectedResultOption, setSelectedResultOption] = useState("");
  const [searchText, setSearchText] = useState("");
  const timeZone = props.results?.timeZone;

  // Helper function to format date according to timezone
  const formatDateWithTimezone = (dateString) => {
    if (!dateString) return "";
    try {
      // Ensure the date string is treated as UTC by appending 'Z' if no timezone info
      let utcDateString = dateString;
      if (
        !dateString.includes("Z") &&
        !dateString.includes("+") &&
        !dateString.match(/[+-]\d{2}:\d{2}$/)
      ) {
        // Replace space with 'T' for ISO format and append 'Z' to indicate UTC
        utcDateString = dateString.replace(" ", "T") + "Z";
      }

      const date = new Date(utcDateString);
      return new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
        .format(date)
        .replace(
          /(\d+)\/(\d+)\/(\d+),\s(\d+):(\d+):(\d+)/,
          "$3-$1-$2 $4:$5:$6"
        );
    } catch (error) {
      return dateString?.slice(0, 19);
    }
  };

  // Filter function for data
  const filterData = (data) => {
    if (!searchText.trim()) return data;

    const lowerSearch = searchText.toLowerCase();
    const matchesValue = (value) => {
      if (value === null || value === undefined) return false;
      return value.toString().toLowerCase().includes(lowerSearch);
    };

    return data.filter((row) => {
      // Entrants rows (GridTableData type=2) carry each result option's value
      // nested under result_options — GridTableData only flattens that onto
      // the row at render time (see its fetchRows), so Object.values(row)
      // here just sees the nested object and stringifies it as
      // "[object Object]". Check result_options separately so searching a
      // result option value (e.g. a handicap/corrected time) actually matches.
      return (
        Object.values(row).some(matchesValue) ||
        (row.result_options && Object.values(row.result_options).some(matchesValue))
      );
    });
  };

  // Handle search text change
  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchText("");
  };

let entrantsStaticColumns = [
     {
      field: "startTime",
      headerName: "Start Time",
      cellClassName: "lastname-cell",
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        <Tooltip
          title={params?.value}
          enterTouchDelay={0}
          leaveTouchDelay={3000}
        >
          <Typography
            noWrap
            style={{ overflow: "hidden", textOverflow: "ellipsis" }}
            variant="p"
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "offsetTime",
      headerName: "Offset Time",
      cellClassName: "lastname-cell",
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        <Tooltip
          title={params?.value}
          enterTouchDelay={0}
          leaveTouchDelay={3000}
        >
          <Typography
            noWrap
            style={{ overflow: "hidden", textOverflow: "ellipsis" }}
            variant="p"
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "sailnum",
      headerName: "Sail #",
      // width: isTablet ? 70 : 100,
      cellClassName: "sailnum-cell",
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "bowNum",
      headerName: "Bow Num",
      // width: isTablet ? 70 : 100,
      cellClassName: "bownum-cell",
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "boatname",
      headerName: "Boat",
      cellClassName: "boatname-cell",
      // width: 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "firstname",
      headerName: "First Name",
      cellClassName: "firstname-cell",
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "lastname",
      headerName: "Last Name",
      cellClassName: "lastname-cell",
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "designName",
      headerName: "Design",
      cellClassName: "designName-cell",
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "classname",
      headerName: "Class",
      cellClassName: "classname-cell",
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "kbClassName",
      headerName: "KB Class",
      cellClassName: "kbClassName-cell",
      renderCell: (params) => (
        <Typography
          noWrap
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "crew1",
      headerName: "Crew 1",
      cellClassName: "crew1-cell",
      renderCell: (params) => (
        <Typography
          noWrap
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "crew2",
      headerName: "Crew 2",
      cellClassName: "crew2-cell",
      renderCell: (params) => (
        <Typography
          noWrap
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "note",
      headerName: "Note",
      cellClassName: "note-cell",
      renderCell: (params) => (
        <Typography
          noWrap
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "note1",
      headerName: "Note 1",
      cellClassName: "note1-cell",
      renderCell: (params) => (
        <Typography
          noWrap
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "casual",
      headerName: "Cas/Vis",
      cellClassName: "casual-cell",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          {params.row.casual ? (
            <CheckIcon style={{ color: "#05a929" }} />
          ) : (
            <CloseIcon style={{ color: "#42566c" }} />
          )}
        </div>
      ),
    },
  ];


  const [ColumnEntrants, setColumnEntrants] = useState([]);

  const ColumnAMS = [
    {
      field: "showPlace",
      headerName: "Result",
      align: "center",
      headerAlign: "center",
      cellClassName: "result-cell",
      // width: isTablet ? 55 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <p style={{ fontWeight: "900 !important" }}>{params.value}</p>
        // </Tooltip>
      ),
    },
    {
      field: "boatName",
      headerName: "Boat Name",
      cellClassName: "boatName-cell",
      // minWidth: 70,
      // width: 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          ////  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "sailnum",
      headerName: "Sail #",
      // minWidth: 70,
      // width: isTablet ? 70 : 100,
      cellClassName: "note-cell",
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          ////  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "note",
      headerName: "Note ",
      // minWidth: 70,
      // width: isTablet ? 70 : 100,
      cellClassName: "note1-cell",
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          ////  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "note1",
      headerName: "Note 1",
      // minWidth: 70,
      // width: isTablet ? 70 : 100,
      cellClassName: "note1-cell",
      renderCell: (params) => (
        <Typography
          noWrap
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "skipper",
      headerName: "Skipper",
      cellClassName: "skipper-cell",
      // minWidth: 70,
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        <Typography
          noWrap
          variant="p"
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "crew1",
      headerName: "Crew1",
      cellClassName: "skipper-cell",
      // minWidth: 70,
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          ////  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "crew2",
      headerName: "Crew2",
      cellClassName: "skipper-cell",
      // minWidth: 70,
      // width: isTablet ? 70 : 100,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          ////  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    ...(props.isCasual === 1
      ? [
        {
          field: "casual",
          headerName: "Cas/Vis",
          cellClassName: "result-cell",
          // minWidth: 70,
          // width: isTablet ? 55 : 100,
          renderCell: (params) => (
            <div
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              {params.row.casual ? (
                <CheckIcon style={{ color: "#05a929" }} />
              ) : (
                <CloseIcon style={{ color: "#42566c" }} />
              )}
            </div>
          ),
        },
      ]
      : []),
    {
      field: "startTime",
      headerName: "Start T",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      cellClassName: "startTime-cell",
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          ////  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "finishTime",
      headerName: "Finish T",
      cellClassName: "finishTime-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "otbClass",
      headerName: "Class",
      cellClassName: "otbClass-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "yardStick",
      headerName: "YS",
      cellClassName: "yardStick-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "yardstickCorrectedTime",
      headerName: "YS COR'DT",
      cellClassName: "yardstickCorrectedTime-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "elapsedTime",
      headerName: "Elapsed T",
      cellClassName: "elapsedTime-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "ahc",
      headerName: "AHC",
      cellClassName: "ahc-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "correctedTime",
      headerName: "Cor'd T",
      cellClassName: "correctedTime-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "bch",
      headerName: "BCH",
      cellClassName: "bch-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "chc",
      headerName: "CHC",
      cellClassName: "chc-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
      renderCell: (params) => (
        // <Tooltip
        //   title={params?.value}
        //   enterTouchDelay={0}
        //   leaveTouchDelay={3000}
        // >
        <Typography
          noWrap
          //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          variant="p"
        >
          {params.value}
        </Typography>
        // </Tooltip>
      ),
    },
    {
      field: "score",
      headerName: "Score",
      align: "center",
      headerAlign: "center",
      // width: isTablet ? 50 : 100,
      // minWidth: 70,
      cellClassName: "score-cell",
      renderCell: (params) => {
        if (params.value === 0 && params.row.casual === true) {
          return "";
        } else {
          return (
            // <Tooltip
            //   title={params?.value}
            //   enterTouchDelay={0}
            //   leaveTouchDelay={3000}
            // >
            <Typography
              noWrap
              //  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
              variant="p"
            >
              {params.value}
            </Typography>
            // </Tooltip>
          );
        }
      },
    },
    {
      field: "pd",
      headerName: "PD",
      cellClassName: "bch-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
    },
    {
      field: "td",
      headerName: "TD",
      cellClassName: "bch-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
    },
    {
      field: "etOrd",
      headerName: "ET Ord",
      cellClassName: "bch-cell",
      // width: isTablet ? 70 : 100,
      // minWidth: 70,
    },
  ];

  const handleChange = async (event, newValue) => {
    setValue(newValue);
    setSearchText("");

    if (props.isSeriesScore) {
      props.setResultOption(props.results.resultOptionComplete[newValue]);
      setSelectedResultOption(props.results.resultOptionComplete[newValue]);
    }
  };

  useEffect(() => {
    const updateColumns = () => {
      if (props.results) {
        const isTabletOrBelow = window.innerWidth <= 1024;

        const additionalColumns = props.results.resultOptionComplete.map(
          (val) => {
            // Measure header text to set proper minWidth
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context.font = "bold 12px Roboto, sans-serif";
            const textWidth = context.measureText(val).width;
            const isMobile = window.innerWidth <= 600;
            const headerMinWidth = Math.max(10, Math.ceil(textWidth + (isMobile ? 16 : 22)));

            return {
              field: val,
              headerName: val,
              minWidth: headerMinWidth,
              renderCell: (params) => (
                <Typography noWrap variant="p">
                  {params.value}
                </Typography>
              ),
            };
          }
        );

        // Reorder the entrants columns based on props.raceSession.columnOrder
        // (set from the entrants/otb-entrants route), mirroring FleetRaceTabs.js.
        let orderedStaticColumns = [...entrantsStaticColumns, ...additionalColumns];
        if (props.raceSession?.columnOrder) {
          try {
            const orderArray = typeof props.raceSession.columnOrder === 'string'
              ? JSON.parse(props.raceSession.columnOrder)
              : props.raceSession.columnOrder;
            if (Array.isArray(orderArray) && orderArray.length > 0) {
              // Columns that should always be at the start
              const priorityFields = ['startTime', 'offsetTime'];

              // Helper function to get field position in columnOrder
              // Handles KB/OTB class field mapping (classname <-> kbClassName)
              const getFieldPosition = (field) => {
                let index = orderArray.indexOf(field);
                if (index === -1) {
                  // If class field not found, try the alternate class field
                  if (field === 'classname' && orderArray.includes('kbClassName')) {
                    index = orderArray.indexOf('kbClassName');
                  } else if (field === 'kbClassName' && orderArray.includes('classname')) {
                    index = orderArray.indexOf('classname');
                  }
                }
                return index === -1 ? orderArray.length : index;
              };

              orderedStaticColumns.sort((a, b) => {
                // Check if columns are priority columns
                const isPriorityA = priorityFields.some(pf => a.field.toLowerCase().includes(pf.toLowerCase()));
                const isPriorityB = priorityFields.some(pf => b.field.toLowerCase().includes(pf.toLowerCase()));

                // Priority columns come first
                if (isPriorityA && !isPriorityB) return -1;
                if (!isPriorityA && isPriorityB) return 1;

                // For non-priority columns, use columnOrder with fallback for class fields
                const posA = getFieldPosition(a.field);
                const posB = getFieldPosition(b.field);
                return posA - posB;
              });
            }
          } catch (e) {
            console.warn('Failed to parse columnOrder:', e);
          }
        }

        setColumnEntrants([...orderedStaticColumns]);
      }
    };

    updateColumns();

    // Handle both resize and orientation change events
    const handleResize = () => {
      // Add small delay to ensure window dimensions are updated after orientation change
      setTimeout(updateColumns, 100);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    // Also listen to screen orientation API if available
    if (window.screen?.orientation) {
      window.screen.orientation.addEventListener("change", handleResize);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      if (window.screen?.orientation) {
        window.screen.orientation.removeEventListener("change", handleResize);
      }
    };
  }, [props.results, props.raceSession]);

  useEffect(() => {
    const isLoggedIn = Boolean(localStorage?.getItem("accessToken"));
    const isPublicResultsPage =
      window.location.pathname.startsWith("/publicresults");

    if (!isLoggedIn || !isPublicResultsPage) return;

    const mainElement = document.querySelector(".ty_application_design main");
    if (!mainElement) return;

    // Check if screen is tablet/mobile (md and below) or desktop (lg and above)
    const isTabletOrMobile = window.innerWidth < 1050; // lg breakpoint in MUI is 1200px

    mainElement.style.setProperty(
      "height",
      isTabletOrMobile ? "calc(100% - 50px)" : "calc(100% - 10px)",
      "important"
    );

    return () => {
      mainElement.style.setProperty("height", "calc(100% - 70px)", "important");
    };
  }, []);

  return (
    <>
      {/* Tabs Section */}
      <div
        style={{
          width: "100%",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          centered
          className="ty_tabs_nav customize_icon_position"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {props.results &&
            props.isSeriesScore &&
            props.results.resultOptionComplete.map((res, index) => (
              <Tab
                key={index}
                className="ty_tabs_nav_text"
                label={res}
                {...a11yProps(index)}
              />
            ))}
          {props.results &&
            !props.isSeriesScore &&
            props.results.resultGroupeds.map((res, index) => (
              <Tab key={index} label={res.resultOption} {...a11yProps(index)} />
            ))}
          {props.results &&
            !props.isSeriesScore &&
            props.results.entrantDetailDTOs.length > 0 && (
              <Tab
                label="ENTRANTS"
                {...a11yProps(props.results.resultGroupeds.length)}
              />
            )}
        </Tabs>
      </div>

      {/* Tab Panels Section For Race results*/}
      {!props.isSeriesScore && (
        <Box margin={"0"} padding={"0px"}>
          {props.results &&
            props.results.resultGroupeds.map((res, index) => {
              return (
                <Grid container spacing={4} key={index}>
                  <Grid item md={12} sm={12} xs={12}>
                    <CustomTabPanel value={value} index={index}>
                      <Box className="ty_pr_tabs_header_text">
                        <Box
                          className="fleet-container"
                          sx={{ display: "flex" }}
                        >
                          <Typography
                            sx={{
                              textAlign: "center",
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "center",
                              gap: "0 4px",
                            }}
                          >
                            <span style={{ whiteSpace: "nowrap" }}>
                              {`${res.resultOption} ${props.selectedFleetLabel} Results `}
                              <span style={{ margin: "0 0.25rem" }}> | </span>
                            </span>
                            <span
                              className="responsive_text_header"
                              style={{
                                whiteSpace: "nowrap",
                                marginRight: "0px",
                              }}
                            >
                              {props.raceSession?.startTime ? (
                                <span style={{ whiteSpace: "nowrap" }}>
                                  {`Start: ${props.raceSession?.startTime
                                    } `}
                                </span>
                              ) : null}
                              {`${props.raceSession?.label} `}
                              <span style={{ margin: "0 0.25rem" }}> | </span>
                            </span>
                            <span style={{ whiteSpace: "nowrap" }}>
                              {`Updated: ${formatDateWithTimezone(
                                res.updatedDate
                              )} (${timeZone})`}
                            </span>
                          </Typography>
                        </Box>
                        {props.raceSession?.note ? (
                          <Box
                            className="fleet-container"
                            sx={{ display: "flex" }}
                          >
                            <Typography
                              sx={{
                                lineHeight: "1",
                                textAlign: "center",
                                fontFamily: "var(--font-family)",
                              }}
                            >
                              {props.raceSession?.note}
                            </Typography>
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                      {/* Search Box */}
                      <Box sx={{ padding: "5px 5px", width: "100%", marginBottom: "0.5rem", textAlign: "center" }}>
                        <TextField
                          fullWidth
                          size="small"
                          placeholder="Search in table..."
                          value={searchText}
                          onChange={handleSearchChange}
                          sx={{
                            "& .MuiInputBase-input": { fontSize: "var(--font_size12)" },
                            "& .MuiInputLabel-root": { fontSize: "var(--font_size12)" },
                            maxWidth:{lg : "700px", md: "100%", sm: "100%", xs: "100%"}
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon sx={{ cursor: "pointer", fontSize: "var(--font_size16) !important" }} />
                              </InputAdornment>
                            ),
                            endAdornment: searchText && (
                              <InputAdornment position="end">
                                <CloseIcon
                                  sx={{ cursor: "pointer", fontSize: "var(--font_size16) !important" }}
                                  onClick={handleClearSearch}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                      <GridTableData
                        columnsSet={(() => {
                          const prc = props.raceSession?.publishedResultColumns?.find(
                            (x) => x.resultOption === res.resultOption
                          );
                          const hiddenMap = prc?.hiddenColumns;
                          const orderArray = prc?.columnOrder;

                          let visibleCols = ColumnAMS;

                          // 1. Apply hidden columns filter
                          if (hiddenMap && typeof hiddenMap === "object" && !Array.isArray(hiddenMap)) {
                            visibleCols = ColumnAMS.filter((col) => hiddenMap[col.field] !== false);
                          }

                          // 2. Apply saved column order
                          if (Array.isArray(orderArray) && orderArray.length > 0) {
                            const fieldMap = new Map(visibleCols.map((c) => [c.field, c]));
                            const ordered = [];
                            orderArray.forEach((f) => { if (fieldMap.has(f)) { ordered.push(fieldMap.get(f)); fieldMap.delete(f); } });
                            fieldMap.forEach((c) => ordered.push(c));
                            visibleCols = ordered;
                          }

                          return visibleCols;
                        })()}
                        data={filterData(res.results)}
                        showColumns={res.columnAMS}
                        type={1}
                        isSeriesScore={props.isSeriesScore}
                        activeTab={value}
                        tabIndex={index}
                      />
                    </CustomTabPanel>
                  </Grid>
                </Grid>
              );
            })}

          {/* Additional Tab Panel for "Entrants" */}
          {props.results && props.results.entrantDetailDTOs.length > 0 && (
            <CustomTabPanel
              value={value}
              index={props.results.resultGroupeds.length}
            >
              <Box className="ty_pr_tabs_header_text">
                <Typography
                  sx={{
                    textAlign: "center",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "0 4px",
                  }}
                >
                  <span style={{ whiteSpace: "nowrap" }}>
                    {(() => {

                      return (
                        (
                          props.raceSession?.startTime ||
                          props.raceSession?.label) && (
                          <>
                            {(props.raceSession?.startTime) &&
                              `Start: ${props.raceSession?.startTime
                              }`}
                            <span style={{ margin: "0 0.25rem" }}> | </span>
                            {props.raceSession?.label?.split(" ")[0]}
                          </>
                        )
                      );
                    })()}
                  </span>
                </Typography>
                {props.raceSession?.note ? (
                  <Box
                    className="fleet-container"
                    sx={{ display: "flex" }}
                  >
                    <Typography
                      sx={{
                        lineHeight: "1",
                        textAlign: "center",
                        fontFamily: "var(--font-family)",
                      }}
                    >
                      {props.raceSession?.note}
                    </Typography>
                  </Box>
                ) : (
                  ""
                )}
              </Box>
              {/* Search Box */}
              <Box sx={{ padding: "5px 5px", width: "100%", marginBottom: "0.5rem", textAlign: "center" }}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Search in table..."
                  value={searchText}
                  onChange={handleSearchChange}
                  sx={{
                    "& .MuiInputBase-input": { fontSize: "var(--font_size12)" },
                    "& .MuiInputLabel-root": { fontSize: "var(--font_size12)" },
                    maxWidth: { lg: "700px", md: "100%", sm: "100%", xs: "100%" }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ cursor: "pointer", fontSize: "var(--font_size16) !important" }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchText && (
                      <InputAdornment position="end">
                        <CloseIcon
                          sx={{ cursor: "pointer", fontSize: "var(--font_size16) !important" }}
                          onClick={handleClearSearch}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              {(() => {
                try {
                  const raw = props.raceSession?.hiddenColumns;
                  const parsed = raw ? JSON.parse(raw) : {};
                  const isClassColumnHidden =
                    parsed?.kbClassName === false ||
                    parsed?.classname === false ||
                    parsed?.className === false;
                  const filtered = (!parsed || Array.isArray(parsed) || typeof parsed !== "object")
                    ? ColumnEntrants
                    : ColumnEntrants.filter((col) => {
                        if (
                          col.field === "kbClassName" ||
                          col.field === "classname" ||
                          col.field === "className"
                        ) {
                          return !isClassColumnHidden;
                        }
                        return parsed[col.field] !== false;
                      });
                  return (
                    <GridTableData
                      columnsSet={filtered}
                      data={filterData(props.results.entrantDetailDTOs)}
                      showColumns={filtered.map((col) => col.field)}
                      type={2}
                      activeTab={value}
                      tabIndex={props?.results?.resultGroupeds?.length}
                    />
                  );
                } catch {
                  return (
                    <GridTableData
                      columnsSet={ColumnEntrants}
                      data={filterData(props.results.entrantDetailDTOs)}
                      showColumns={ColumnEntrants?.map((col) => col.field)}
                      type={2}
                      activeTab={value}
                      tabIndex={props?.results?.resultGroupeds?.length}
                    />
                  );
                }
              })()}
            </CustomTabPanel>
          )}
        </Box>
      )}

      {/* Tab Panels Section For Series Scores*/}
      {props.isSeriesScore && (
        <Box
        // border={"1px solid #E0E5EB"}
        // margin={"0 5% 24px 5%"}
        >
          {props.results && props.results.resultGroupeds.length > 0 ? (
            props.results.resultOptionComplete.map((ro, index) => (
              <CustomTabPanel key={index} value={value} index={index}>
                <Box className="ty_pr_tabs_header_text">
                  <Typography>{`${ro} ${props.selectedFleetLabel}`}</Typography>
                </Box>
                {/* Search Box */}
                <Box sx={{ padding: "5px 5px", width: "100%", marginBottom: "0.5rem", textAlign: "center" }}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search in table..."
                    value={searchText}
                    onChange={handleSearchChange}
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "var(--font_size12)" },
                      "& .MuiInputLabel-root": { fontSize: "var(--font_size12)" },
                      maxWidth: { lg: "700px", md: "100%", sm: "100%", xs: "100%" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ cursor: "pointer", fontSize: "var(--font_size16) !important" }} />
                        </InputAdornment>
                      ),
                      endAdornment: searchText && (
                        <InputAdornment position="end">
                          <CloseIcon
                            sx={{ cursor: "pointer", fontSize: "var(--font_size16) !important" }}
                            onClick={handleClearSearch}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <GridTableData
                  columnsSet={props.seriesScoreCols}
                  data={filterData(
                    props.results.resultGroupeds.find(
                      (x) => x.resultOption == selectedResultOption
                    )
                      ? props.results.resultGroupeds.find(
                        (x) => x.resultOption == selectedResultOption
                      ).results
                      : props.results.resultGroupeds[0].results
                  )}
                  showColumns={
                    props.results.resultGroupeds.find(
                      (x) => x.resultOption == selectedResultOption
                    )
                      ? props.results.resultGroupeds.find(
                        (x) => x.resultOption == selectedResultOption
                      ).columns
                      : props.results.resultGroupeds[0].columns
                  }
                  type={1}
                  isSeriesScore={props.isSeriesScore}
                  loader={props.loader}
                  activeTab={value}
                  tabIndex={index}
                />
              </CustomTabPanel>
            ))
          ) : (
            <NoResultsPublished />
          )}
        </Box>
      )}
    </>
  );
};

export default FleetRaceTabsv2;